import { Wallet } from "./wallet";
import { Address } from "../address";

export abstract class TradableWallet extends Wallet {
	protected is_default: boolean = false;
	protected deleted: boolean = false;
	protected cryptocoin_id: string = "";

	public abstract getAddresses(): Address[];
	public abstract setAddresses(addresses: Address[]): void;

	public getCurrencyId(): string {
		return this.cryptocoin_id;
	}

	public setCurrencyId(id: string): void {
		this.cryptocoin_id = id;
	}

	public isDeleted(): boolean {
		return this.deleted;
	}

	public isDefault(): boolean {
		return this.is_default;
	}

	public setDefault(b: boolean): void {
		this.is_default = b;
	}

	public isDerivative(): boolean {
		return false;
	}

	public isNew(): boolean {
		return this.isNewWallet;
	}

	public setNew(b: boolean): void {
		this.isNewWallet = b;
	}

	public getBaseUrl(): string {
		return "/wallet/";
	}
}
